class Ordered {
  apply(data, order) {
    if (order.length === 0) {
      return data;
    }

    let columns = data;
    let selections = [];

    for (const element of order) {
      const index = columns.findIndex((item) => item.key === element);

      if (index !== -1) {
        const value = columns[index];

        columns = columns.filter((item) => item.key !== element);

        selections.push({
          ...value,
          checked: true,
        });
      }
    }

    return [columns, selections];
  }
}

export default Ordered;
